// extracted by mini-css-extract-plugin
module.exports = {"SectionOpenPbScreenBeta":"App__SectionOpenPbScreenBeta__3MJAz","SectionOpenPbScreenStable":"App__SectionOpenPbScreenStable__CTH8U"};